// Generated at 12/15/2025, 11:13:49 PM

export const unitsObject = {
  'radian': [0, 1],
  'radians': [0, 1],
  'rad': [0, 1],
  'rads': [0, 1],
  'r': [0, 1],
  'turn': [0, 2 * Math.PI],
  'turns': [0, 2 * Math.PI],
  'degree': [0, Math.PI / 180],
  'degrees': [0, Math.PI / 180],
  'deg': [0, Math.PI / 180],
  'degs': [0, Math.PI / 180],
  '°': [0, Math.PI / 180],
  'gradian': [0, Math.PI / 200],
  'gradians': [0, Math.PI / 200],
  'gon': [0, Math.PI / 200],
  'gons': [0, Math.PI / 200],
  'grad': [0, Math.PI / 200],
  'grads': [0, Math.PI / 200],
  'grade': [0, Math.PI / 200],
  'grades': [0, Math.PI / 200],
  'arcminute': [0, Math.PI / 10800],
  'arcminutes': [0, Math.PI / 10800],
  'minutes of arc': [0, Math.PI / 10800],
  'arcmin': [0, Math.PI / 10800],
  'arcmins': [0, Math.PI / 10800],
  'arcsecond': [0, Math.PI / 648000],
  'arcseconds': [0, Math.PI / 648000],
  'seconds of arc': [0, Math.PI / 648000],
  'arcsec': [0, Math.PI / 648000],
  'arcsecs': [0, Math.PI / 648000],
  'square meter': [1, 1],
  'square meters': [1, 1],
  'square metre': [1, 1],
  'square metres': [1, 1],
  'm²': [1, 1],
  'm2': [1, 1],
  'square petameter': [1, 1e+30],
  'square petametre': [1, 1e+30],
  'square petameters': [1, 1e+30],
  'square petametres': [1, 1e+30],
  'Pm²': [1, 1e+30],
  'Pm2': [1, 1e+30],
  'square terameter': [1, 1e+24],
  'square terametre': [1, 1e+24],
  'square terameters': [1, 1e+24],
  'square terametres': [1, 1e+24],
  'Tm²': [1, 1e+24],
  'Tm2': [1, 1e+24],
  'square gigameter': [1, 1000000000000000000],
  'square gigametre': [1, 1000000000000000000],
  'square gigameters': [1, 1000000000000000000],
  'square gigametres': [1, 1000000000000000000],
  'Gm²': [1, 1000000000000000000],
  'Gm2': [1, 1000000000000000000],
  'square megameter': [1, 1000000000000],
  'square megametre': [1, 1000000000000],
  'square megameters': [1, 1000000000000],
  'square megametres': [1, 1000000000000],
  'Mm²': [1, 1000000000000],
  'Mm2': [1, 1000000000000],
  'square kilometer': [1, 1000000],
  'square kilometre': [1, 1000000],
  'square kilometers': [1, 1000000],
  'square kilometres': [1, 1000000],
  'km²': [1, 1000000],
  'km2': [1, 1000000],
  'square hectometer': [1, 10000],
  'square hectometre': [1, 10000],
  'square hectometers': [1, 10000],
  'square hectometres': [1, 10000],
  'hm²': [1, 10000],
  'hm2': [1, 10000],
  'square decameter': [1, 100],
  'square decametre': [1, 100],
  'square decameters': [1, 100],
  'square decametres': [1, 100],
  'dam²': [1, 100],
  'dam2': [1, 100],
  'square decimeter': [1, 0.1],
  'square decimetre': [1, 0.1],
  'square decimeters': [1, 0.1],
  'square decimetres': [1, 0.1],
  'dm²': [1, 0.1],
  'dm2': [1, 0.1],
  'square centimeter': [1, 0.0001],
  'square centimetre': [1, 0.0001],
  'square centimeters': [1, 0.0001],
  'square centimetres': [1, 0.0001],
  'cm²': [1, 0.0001],
  'cm2': [1, 0.0001],
  'square millimeter': [1, 0.000001],
  'square millimetre': [1, 0.000001],
  'square millimeters': [1, 0.000001],
  'square millimetres': [1, 0.000001],
  'mm²': [1, 0.000001],
  'mm2': [1, 0.000001],
  'square micrometer': [1, 1e-12],
  'square micrometre': [1, 1e-12],
  'square micrometers': [1, 1e-12],
  'square micrometres': [1, 1e-12],
  'μm²': [1, 1e-12],
  'µm²': [1, 1e-12],
  'μm2': [1, 1e-12],
  'µm2': [1, 1e-12],
  'square nanometer': [1, 1e-18],
  'square nanometre': [1, 1e-18],
  'square nanometers': [1, 1e-18],
  'square nanometres': [1, 1e-18],
  'nm²': [1, 1e-18],
  'nm2': [1, 1e-18],
  'square picometer': [1, 1e-24],
  'square picometre': [1, 1e-24],
  'square picometers': [1, 1e-24],
  'square picometres': [1, 1e-24],
  'pm²': [1, 1e-24],
  'pm2': [1, 1e-24],
  'square femtometer': [1, 1e-30],
  'square femtometre': [1, 1e-30],
  'square femtometers': [1, 1e-30],
  'square femtometres': [1, 1e-30],
  'fm²': [1, 1e-30],
  'fm2': [1, 1e-30],
  'acre': [1, 4046.8564224],
  'acres': [1, 4046.8564224],
  'ac': [1, 4046.8564224],
  'centiare': [1, 1],
  'centiares': [1, 1],
  'ca': [1, 1],
  'deciare': [1, 10],
  'deciares': [1, 10],
  'da': [1, 10],
  'are': [1, 100],
  'ares': [1, 100],
  'decare': [1, 1000],
  'decares': [1, 1000],
  'daa': [1, 1000],
  'hectare': [1, 10000],
  'hectares': [1, 10000],
  'ha': [1, 10000],
  'square foot': [1, 0.09290304],
  'square feet': [1, 0.09290304],
  'sq ft': [1, 0.09290304],
  'ft²': [1, 0.09290304],
  'ft2': [1, 0.09290304],
  'square inch': [1, 0.00064516],
  'square inches': [1, 0.00064516],
  'sq in': [1, 0.00064516],
  'in²': [1, 0.00064516],
  'in2': [1, 0.00064516],
  'square yard': [1, 0.83612736],
  'square yards': [1, 0.83612736],
  'sq yd': [1, 0.83612736],
  'yd²': [1, 0.83612736],
  'yd2': [1, 0.83612736],
  'square mile': [1, 2589988.110336],
  'square miles': [1, 2589988.110336],
  'sq mi': [1, 2589988.110336],
  'mi²': [1, 2589988.110336],
  'mi2': [1, 2589988.110336],
  'mǔ': [1, 666.6666666666666],
  'mu': [1, 666.6666666666666],
  'bit': [2, 1],
  'bits': [2, 1],
  'b': [2, 1],
  'pebibit': [2, 1125899906842624],
  'pebibits': [2, 1125899906842624],
  'Pib': [2, 1125899906842624],
  'tebibit': [2, 1099511627776],
  'tebibits': [2, 1099511627776],
  'Tib': [2, 1099511627776],
  'gibibit': [2, 1073741824],
  'gibibits': [2, 1073741824],
  'Gib': [2, 1073741824],
  'mebibit': [2, 1048576],
  'mebibits': [2, 1048576],
  'Mib': [2, 1048576],
  'kibibit': [2, 1024],
  'kibibits': [2, 1024],
  'Kib': [2, 1024],
  'Kb': [2, 1000],
  'KB': [2, 8000],
  'petabit': [2, 1000000000000000],
  'petabits': [2, 1000000000000000],
  'Pb': [2, 1000000000000000],
  'terabit': [2, 1000000000000],
  'terabits': [2, 1000000000000],
  'Tb': [2, 1000000000000],
  'gigabit': [2, 1000000000],
  'gigabits': [2, 1000000000],
  'Gb': [2, 1000000000],
  'megabit': [2, 1000000],
  'megabits': [2, 1000000],
  'Mb': [2, 1000000],
  'kilobit': [2, 1000],
  'kilobits': [2, 1000],
  'kb': [2, 1000],
  'hectobit': [2, 100],
  'hectobits': [2, 100],
  'hb': [2, 100],
  'decabit': [2, 10],
  'decabits': [2, 10],
  'dab': [2, 10],
  'decibit': [2, 0.1],
  'decibits': [2, 0.1],
  'db': [2, 0.1],
  'centibit': [2, 0.01],
  'centibits': [2, 0.01],
  'cb': [2, 0.01],
  'millibit': [2, 0.001],
  'millibits': [2, 0.001],
  'mb': [2, 0.001],
  'microbit': [2, 0.000001],
  'microbits': [2, 0.000001],
  'μb': [2, 0.000001],
  'µb': [2, 0.000001],
  'nanobit': [2, 1e-9],
  'nanobits': [2, 1e-9],
  'nb': [2, 1e-9],
  'picobit': [2, 1e-12],
  'picobits': [2, 1e-12],
  'pb': [2, 1e-12],
  'femtobit': [2, 1e-15],
  'femtobits': [2, 1e-15],
  'fb': [2, 1e-15],
  'nibble': [2, 4],
  'nibbles': [2, 4],
  'semioctet': [2, 4],
  'semioctets': [2, 4],
  'halfbyte': [2, 4],
  'halfbytes': [2, 4],
  'byte': [2, 8],
  'bytes': [2, 8],
  'octect': [2, 8],
  'octects': [2, 8],
  'B': [2, 8],
  'pebibyte': [2, 9007199254740992],
  'pebibytes': [2, 9007199254740992],
  'PiB': [2, 9007199254740992],
  'tebibyte': [2, 8796093022208],
  'tebibytes': [2, 8796093022208],
  'TiB': [2, 8796093022208],
  'gibibyte': [2, 8589934592],
  'gibibytes': [2, 8589934592],
  'GiB': [2, 8589934592],
  'mebibyte': [2, 8388608],
  'mebibytes': [2, 8388608],
  'MiB': [2, 8388608],
  'kibibyte': [2, 8192],
  'kibibytes': [2, 8192],
  'KiB': [2, 8192],
  'petabyte': [2, 8000000000000000],
  'petabytes': [2, 8000000000000000],
  'PB': [2, 8000000000000000],
  'terabyte': [2, 8000000000000],
  'terabytes': [2, 8000000000000],
  'TB': [2, 8000000000000],
  'gigabyte': [2, 8000000000],
  'gigabytes': [2, 8000000000],
  'GB': [2, 8000000000],
  'megabyte': [2, 8000000],
  'megabytes': [2, 8000000],
  'MB': [2, 8000000],
  'kilobyte': [2, 8000],
  'kilobytes': [2, 8000],
  'kB': [2, 8000],
  'hectobyte': [2, 800],
  'hectobytes': [2, 800],
  'hB': [2, 800],
  'decabyte': [2, 80],
  'decabytes': [2, 80],
  'daB': [2, 80],
  'decibyte': [2, 0.8],
  'decibytes': [2, 0.8],
  'dB': [2, 0.8],
  'centibyte': [2, 0.08],
  'centibytes': [2, 0.08],
  'cB': [2, 0.08],
  'millibyte': [2, 0.008],
  'millibytes': [2, 0.008],
  'mB': [2, 0.008],
  'microbyte': [2, 0.000008],
  'microbytes': [2, 0.000008],
  'μB': [2, 0.000008],
  'µB': [2, 0.000008],
  'nanobyte': [2, 8e-9],
  'nanobytes': [2, 8e-9],
  'nB': [2, 8e-9],
  'picobyte': [2, 8e-12],
  'picobytes': [2, 8e-12],
  'pB': [2, 8e-12],
  'femtobyte': [2, 8e-15],
  'femtobytes': [2, 8e-15],
  'fB': [2, 8e-15],
  'hextet': [2, 16],
  'hextets': [2, 16],
  'joule': [3, 1],
  'joules': [3, 1],
  'J': [3, 1],
  'petajoule': [3, 1000000000000000],
  'petajoules': [3, 1000000000000000],
  'PJ': [3, 1000000000000000],
  'terajoule': [3, 1000000000000],
  'terajoules': [3, 1000000000000],
  'TJ': [3, 1000000000000],
  'gigajoule': [3, 1000000000],
  'gigajoules': [3, 1000000000],
  'GJ': [3, 1000000000],
  'megajoule': [3, 1000000],
  'megajoules': [3, 1000000],
  'MJ': [3, 1000000],
  'kilojoule': [3, 1000],
  'kilojoules': [3, 1000],
  'kJ': [3, 1000],
  'hectojoule': [3, 100],
  'hectojoules': [3, 100],
  'hJ': [3, 100],
  'decajoule': [3, 10],
  'decajoules': [3, 10],
  'daJ': [3, 10],
  'decijoule': [3, 0.1],
  'decijoules': [3, 0.1],
  'dJ': [3, 0.1],
  'centijoule': [3, 0.01],
  'centijoules': [3, 0.01],
  'cJ': [3, 0.01],
  'millijoule': [3, 0.001],
  'millijoules': [3, 0.001],
  'mJ': [3, 0.001],
  'microjoule': [3, 0.000001],
  'microjoules': [3, 0.000001],
  'μJ': [3, 0.000001],
  'µJ': [3, 0.000001],
  'nanojoule': [3, 1e-9],
  'nanojoules': [3, 1e-9],
  'nJ': [3, 1e-9],
  'picojoule': [3, 1e-12],
  'picojoules': [3, 1e-12],
  'pJ': [3, 1e-12],
  'femtojoule': [3, 1e-15],
  'femtojoules': [3, 1e-15],
  'fJ': [3, 1e-15],
  'watt-hour': [3, 3600],
  'W⋅h': [3, 3600],
  'W h': [3, 3600],
  'Wh': [3, 3600],
  'petawatt-hour': [3, 3600000000000000000],
  'petawatt-hours': [3, 3600000000000000000],
  'PW⋅h': [3, 3600000000000000000],
  'PW h': [3, 3600000000000000000],
  'PWh': [3, 3600000000000000000],
  'terawatt-hour': [3, 3600000000000000],
  'terawatt-hours': [3, 3600000000000000],
  'TW⋅h': [3, 3600000000000000],
  'TW h': [3, 3600000000000000],
  'TWh': [3, 3600000000000000],
  'gigawatt-hour': [3, 3600000000000],
  'gigawatt-hours': [3, 3600000000000],
  'GW⋅h': [3, 3600000000000],
  'GW h': [3, 3600000000000],
  'GWh': [3, 3600000000000],
  'megawatt-hour': [3, 3600000000],
  'megawatt-hours': [3, 3600000000],
  'MW⋅h': [3, 3600000000],
  'MW h': [3, 3600000000],
  'MWh': [3, 3600000000],
  'kilowatt-hour': [3, 3600000],
  'kilowatt-hours': [3, 3600000],
  'kW⋅h': [3, 3600000],
  'kW h': [3, 3600000],
  'kWh': [3, 3600000],
  'hectowatt-hour': [3, 360000],
  'hectowatt-hours': [3, 360000],
  'hW⋅h': [3, 360000],
  'hW h': [3, 360000],
  'hWh': [3, 360000],
  'decawatt-hour': [3, 36000],
  'decawatt-hours': [3, 36000],
  'daW⋅h': [3, 36000],
  'daW h': [3, 36000],
  'daWh': [3, 36000],
  'deciwatt-hour': [3, 360],
  'deciwatt-hours': [3, 360],
  'dW⋅h': [3, 360],
  'dW h': [3, 360],
  'dWh': [3, 360],
  'centiwatt-hour': [3, 36],
  'centiwatt-hours': [3, 36],
  'cW⋅h': [3, 36],
  'cW h': [3, 36],
  'cWh': [3, 36],
  'milliwatt-hour': [3, 3.6],
  'milliwatt-hours': [3, 3.6],
  'mW⋅h': [3, 3.6],
  'mW h': [3, 3.6],
  'mWh': [3, 3.6],
  'microwatt-hour': [3, 0.0036],
  'microwatt-hours': [3, 0.0036],
  'μW⋅h': [3, 0.0036],
  'µW⋅h': [3, 0.0036],
  'μW h': [3, 0.0036],
  'µW h': [3, 0.0036],
  'μWh': [3, 0.0036],
  'µWh': [3, 0.0036],
  'nanowatt-hour': [3, 0.0000036],
  'nanowatt-hours': [3, 0.0000036],
  'nW⋅h': [3, 0.0000036],
  'nW h': [3, 0.0000036],
  'nWh': [3, 0.0000036],
  'picowatt-hour': [3, 3.6e-9],
  'picowatt-hours': [3, 3.6e-9],
  'pW⋅h': [3, 3.6e-9],
  'pW h': [3, 3.6e-9],
  'pWh': [3, 3.6e-9],
  'femtowatt-hour': [3, 3.6e-12],
  'femtowatt-hours': [3, 3.6e-12],
  'fW⋅h': [3, 3.6e-12],
  'fW h': [3, 3.6e-12],
  'fWh': [3, 3.6e-12],
  'newton': [4, 1],
  'newtons': [4, 1],
  'N': [4, 1],
  'petanewton': [4, 1000000000000000],
  'petanewtons': [4, 1000000000000000],
  'PN': [4, 1000000000000000],
  'teranewton': [4, 1000000000000],
  'teranewtons': [4, 1000000000000],
  'TN': [4, 1000000000000],
  'giganewton': [4, 1000000000],
  'giganewtons': [4, 1000000000],
  'GN': [4, 1000000000],
  'meganewton': [4, 1000000],
  'meganewtons': [4, 1000000],
  'MN': [4, 1000000],
  'kilonewton': [4, 1000],
  'kilonewtons': [4, 1000],
  'kN': [4, 1000],
  'hectonewton': [4, 100],
  'hectonewtons': [4, 100],
  'hN': [4, 100],
  'decanewton': [4, 10],
  'decanewtons': [4, 10],
  'daN': [4, 10],
  'decinewton': [4, 0.1],
  'decinewtons': [4, 0.1],
  'dN': [4, 0.1],
  'centinewton': [4, 0.01],
  'centinewtons': [4, 0.01],
  'cN': [4, 0.01],
  'millinewton': [4, 0.001],
  'millinewtons': [4, 0.001],
  'mN': [4, 0.001],
  'micronewton': [4, 0.000001],
  'micronewtons': [4, 0.000001],
  'μN': [4, 0.000001],
  'µN': [4, 0.000001],
  'nanonewton': [4, 1e-9],
  'nanonewtons': [4, 1e-9],
  'nN': [4, 1e-9],
  'piconewton': [4, 1e-12],
  'piconewtons': [4, 1e-12],
  'pN': [4, 1e-12],
  'femtonewton': [4, 1e-15],
  'femtonewtons': [4, 1e-15],
  'fN': [4, 1e-15],
  'dyne': [4, 0.00001],
  'dynes': [4, 0.00001],
  'dyn': [4, 0.00001],
  'pound of force': [4, 4.448222],
  'pound-force': [4, 4.448222],
  'lbf': [4, 4.448222],
  'kip': [4, 4448.2216],
  'klb': [4, 4448.2216],
  'kipf': [4, 4448.2216],
  'klbf': [4, 4448.2216],
  'poundal': [4, 0.138255],
  'poundals': [4, 0.138255],
  'pdl': [4, 0.138255],
  'kilogram-force': [4, 9.80665],
  'kilopond': [4, 9.80665],
  'kiloponds': [4, 9.80665],
  'kgf': [4, 9.80665],
  'kp': [4, 9.80665],
  'tonne-force': [4, 9806.65],
  'metric ton-force': [4, 9806.65],
  'megagram-force': [4, 9806.65],
  'megapond': [4, 9806.65],
  'tf': [4, 9806.65],
  'Mp': [4, 9806.65],
  'hertz': [5, 1],
  'Hz': [5, 1],
  'petahertz': [5, 1000000000000000],
  'PHz': [5, 1000000000000000],
  'terahertz': [5, 1000000000000],
  'THz': [5, 1000000000000],
  'gigahertz': [5, 1000000000],
  'GHz': [5, 1000000000],
  'megahertz': [5, 1000000],
  'MHz': [5, 1000000],
  'kilohertz': [5, 1000],
  'kHz': [5, 1000],
  'hectohertz': [5, 100],
  'hHz': [5, 100],
  'decahertz': [5, 10],
  'daHz': [5, 10],
  'decihertz': [5, 0.1],
  'dHz': [5, 0.1],
  'centihertz': [5, 0.01],
  'cHz': [5, 0.01],
  'millihertz': [5, 0.001],
  'mHz': [5, 0.001],
  'microhertz': [5, 0.000001],
  'μHz': [5, 0.000001],
  'µHz': [5, 0.000001],
  'nanohertz': [5, 1e-9],
  'nHz': [5, 1e-9],
  'picohertz': [5, 1e-12],
  'pHz': [5, 1e-12],
  'femtohertz': [5, 1e-15],
  'fHz': [5, 1e-15],
  'meter': [6, 1],
  'meters': [6, 1],
  'metre': [6, 1],
  'metres': [6, 1],
  'm': [6, 1],
  'petameter': [6, 1000000000000000],
  'petametre': [6, 1000000000000000],
  'petameters': [6, 1000000000000000],
  'petametres': [6, 1000000000000000],
  'Pm': [6, 1000000000000000],
  'terameter': [6, 1000000000000],
  'terametre': [6, 1000000000000],
  'terameters': [6, 1000000000000],
  'terametres': [6, 1000000000000],
  'Tm': [6, 1000000000000],
  'gigameter': [6, 1000000000],
  'gigametre': [6, 1000000000],
  'gigameters': [6, 1000000000],
  'gigametres': [6, 1000000000],
  'Gm': [6, 1000000000],
  'megameter': [6, 1000000],
  'megametre': [6, 1000000],
  'megameters': [6, 1000000],
  'megametres': [6, 1000000],
  'Mm': [6, 1000000],
  'kilometer': [6, 1000],
  'kilometre': [6, 1000],
  'kilometers': [6, 1000],
  'kilometres': [6, 1000],
  'km': [6, 1000],
  'hectometer': [6, 100],
  'hectometre': [6, 100],
  'hectometers': [6, 100],
  'hectometres': [6, 100],
  'hm': [6, 100],
  'decameter': [6, 10],
  'decametre': [6, 10],
  'decameters': [6, 10],
  'decametres': [6, 10],
  'dam': [6, 10],
  'decimeter': [6, 0.1],
  'decimetre': [6, 0.1],
  'decimeters': [6, 0.1],
  'decimetres': [6, 0.1],
  'dm': [6, 0.1],
  'centimeter': [6, 0.01],
  'centimetre': [6, 0.01],
  'centimeters': [6, 0.01],
  'centimetres': [6, 0.01],
  'cm': [6, 0.01],
  'millimeter': [6, 0.001],
  'millimetre': [6, 0.001],
  'millimeters': [6, 0.001],
  'millimetres': [6, 0.001],
  'mm': [6, 0.001],
  'micrometer': [6, 0.000001],
  'micrometre': [6, 0.000001],
  'micrometers': [6, 0.000001],
  'micrometres': [6, 0.000001],
  'μm': [6, 0.000001],
  'µm': [6, 0.000001],
  'nanometer': [6, 1e-9],
  'nanometre': [6, 1e-9],
  'nanometers': [6, 1e-9],
  'nanometres': [6, 1e-9],
  'nm': [6, 1e-9],
  'picometer': [6, 1e-12],
  'picometre': [6, 1e-12],
  'picometers': [6, 1e-12],
  'picometres': [6, 1e-12],
  'pm': [6, 1e-12],
  'femtometer': [6, 1e-15],
  'femtometre': [6, 1e-15],
  'femtometers': [6, 1e-15],
  'femtometres': [6, 1e-15],
  'fm': [6, 1e-15],
  'foot': [6, 0.3048],
  'feet': [6, 0.3048],
  'ft': [6, 0.3048],
  '\'': [6, 0.3048],
  'US survey foot': [6, 0.30480060960121920244],
  'US survey feet': [6, 0.30480060960121920244],
  'U.S. survey foot': [6, 0.30480060960121920244],
  'U.S. survey feet': [6, 0.30480060960121920244],
  'inch': [6, 0.0254],
  'inches': [6, 0.0254],
  'in': [6, 0.0254],
  '\"': [6, 0.0254],
  'yard': [6, 0.9144],
  'yards': [6, 0.9144],
  'yd': [6, 0.9144],
  'mile': [6, 1609.344],
  'miles': [6, 1609.344],
  'mi': [6, 1609.344],
  'nautical mile': [6, 1852],
  'nautical miles': [6, 1852],
  'M': [6, 1852],
  'NM': [6, 1852],
  'nmi': [6, 1852],
  'light-year': [6, 9460730472580800],
  'light-years': [6, 9460730472580800],
  'ly': [6, 9460730472580800],
  'pica': [6, 0.0042333],
  'picas': [6, 0.0042333],
  'pc': [6, 0.0042333],
  'point': [6, 0.0003528],
  'points': [6, 0.0003528],
  'gram': [7, 1],
  'grams': [7, 1],
  'g': [7, 1],
  'petagram': [7, 1000000000000000],
  'petagrams': [7, 1000000000000000],
  'Pg': [7, 1000000000000000],
  'teragram': [7, 1000000000000],
  'teragrams': [7, 1000000000000],
  'Tg': [7, 1000000000000],
  'gigagram': [7, 1000000000],
  'gigagrams': [7, 1000000000],
  'Gg': [7, 1000000000],
  'megagram': [7, 1000000],
  'megagrams': [7, 1000000],
  'Mg': [7, 1000000],
  'kilogram': [7, 1000],
  'kilograms': [7, 1000],
  'kg': [7, 1000],
  'hectogram': [7, 100],
  'hectograms': [7, 100],
  'hg': [7, 100],
  'decagram': [7, 10],
  'decagrams': [7, 10],
  'dag': [7, 10],
  'decigram': [7, 0.1],
  'decigrams': [7, 0.1],
  'dg': [7, 0.1],
  'centigram': [7, 0.01],
  'centigrams': [7, 0.01],
  'cg': [7, 0.01],
  'milligram': [7, 0.001],
  'milligrams': [7, 0.001],
  'mg': [7, 0.001],
  'microgram': [7, 0.000001],
  'micrograms': [7, 0.000001],
  'μg': [7, 0.000001],
  'µg': [7, 0.000001],
  'nanogram': [7, 1e-9],
  'nanograms': [7, 1e-9],
  'ng': [7, 1e-9],
  'picogram': [7, 1e-12],
  'picograms': [7, 1e-12],
  'pg': [7, 1e-12],
  'femtogram': [7, 1e-15],
  'femtograms': [7, 1e-15],
  'fg': [7, 1e-15],
  'mcg': [7, 0.000001],
  'tonne': [7, 1000000],
  'tonnes': [7, 1000000],
  'metric ton': [7, 1000000],
  'metric tons': [7, 1000000],
  't': [7, 1000000],
  'kilotonne': [7, 1000000000],
  'kilotonnes': [7, 1000000000],
  'kt': [7, 1000000000],
  'megatonne': [7, 1000000000000],
  'megatonnes': [7, 1000000000000],
  'Mt': [7, 1000000000000],
  'gigatonne': [7, 1000000000000000],
  'gigatonnes': [7, 1000000000000000],
  'Gt': [7, 1000000000000000],
  'pound': [7, 453.59237],
  'pounds': [7, 453.59237],
  'lb': [7, 453.59237],
  'lbs': [7, 453.59237],
  'grain': [7, 0.06479891],
  'grains': [7, 0.06479891],
  'gr': [7, 0.06479891],
  'stone': [7, 6350.29318],
  'stones': [7, 6350.29318],
  'st': [7, 6350.29318],
  'ounce': [7, 28.349523125],
  'ounces': [7, 28.349523125],
  'oz': [7, 28.349523125],
  'short hundredweight': [7, 45360],
  'cental': [7, 45360],
  'long hundredweight': [7, 50800],
  'imperial hundredweight': [7, 50800],
  'cwt': [7, 50800],
  'short ton': [7, 907184.74],
  'short tons': [7, 907184.74],
  'US ton': [7, 907184.74],
  'US tons': [7, 907184.74],
  'long ton': [7, 1016046.9088],
  'long tons': [7, 1016046.9088],
  'imperial ton': [7, 1016046.9088],
  'imperial tons': [7, 1016046.9088],
  'displacement ton': [7, 1016046.9088],
  'displacement tons': [7, 1016046.9088],
  'troy ounce': [7, 31.1034768],
  'oz t': [7, 31.1034768],
  'toz': [7, 31.1034768],
  'watt': [8, 1],
  'watts': [8, 1],
  'W': [8, 1],
  'petawatt': [8, 1000000000000000],
  'petawatts': [8, 1000000000000000],
  'PW': [8, 1000000000000000],
  'terawatt': [8, 1000000000000],
  'terawatts': [8, 1000000000000],
  'TW': [8, 1000000000000],
  'gigawatt': [8, 1000000000],
  'gigawatts': [8, 1000000000],
  'GW': [8, 1000000000],
  'megawatt': [8, 1000000],
  'megawatts': [8, 1000000],
  'MW': [8, 1000000],
  'kilowatt': [8, 1000],
  'kilowatts': [8, 1000],
  'kW': [8, 1000],
  'hectowatt': [8, 100],
  'hectowatts': [8, 100],
  'hW': [8, 100],
  'decawatt': [8, 10],
  'decawatts': [8, 10],
  'daW': [8, 10],
  'deciwatt': [8, 0.1],
  'deciwatts': [8, 0.1],
  'dW': [8, 0.1],
  'centiwatt': [8, 0.01],
  'centiwatts': [8, 0.01],
  'cW': [8, 0.01],
  'milliwatt': [8, 0.001],
  'milliwatts': [8, 0.001],
  'mW': [8, 0.001],
  'microwatt': [8, 0.000001],
  'microwatts': [8, 0.000001],
  'μW': [8, 0.000001],
  'µW': [8, 0.000001],
  'nanowatt': [8, 1e-9],
  'nanowatts': [8, 1e-9],
  'nW': [8, 1e-9],
  'picowatt': [8, 1e-12],
  'picowatts': [8, 1e-12],
  'pW': [8, 1e-12],
  'femtowatt': [8, 1e-15],
  'femtowatts': [8, 1e-15],
  'fW': [8, 1e-15],
  'horsepower': [8, 745.699872],
  'mechanical horsepower': [8, 745.699872],
  'hp': [8, 745.699872],
  'pascal': [9, 1],
  'pascals': [9, 1],
  'Pa': [9, 1],
  'petapascal': [9, 1000000000000000],
  'petapascals': [9, 1000000000000000],
  'PPa': [9, 1000000000000000],
  'terapascal': [9, 1000000000000],
  'terapascals': [9, 1000000000000],
  'TPa': [9, 1000000000000],
  'gigapascal': [9, 1000000000],
  'gigapascals': [9, 1000000000],
  'GPa': [9, 1000000000],
  'megapascal': [9, 1000000],
  'megapascals': [9, 1000000],
  'MPa': [9, 1000000],
  'kilopascal': [9, 1000],
  'kilopascals': [9, 1000],
  'kPa': [9, 1000],
  'hectopascal': [9, 100],
  'hectopascals': [9, 100],
  'hPa': [9, 100],
  'decapascal': [9, 10],
  'decapascals': [9, 10],
  'daPa': [9, 10],
  'decipascal': [9, 0.1],
  'decipascals': [9, 0.1],
  'dPa': [9, 0.1],
  'centipascal': [9, 0.01],
  'centipascals': [9, 0.01],
  'cPa': [9, 0.01],
  'millipascal': [9, 0.001],
  'millipascals': [9, 0.001],
  'mPa': [9, 0.001],
  'micropascal': [9, 0.000001],
  'micropascals': [9, 0.000001],
  'μPa': [9, 0.000001],
  'µPa': [9, 0.000001],
  'nanopascal': [9, 1e-9],
  'nanopascals': [9, 1e-9],
  'nPa': [9, 1e-9],
  'picopascal': [9, 1e-12],
  'picopascals': [9, 1e-12],
  'pPa': [9, 1e-12],
  'femtopascal': [9, 1e-15],
  'femtopascals': [9, 1e-15],
  'fPa': [9, 1e-15],
  'bar': [9, 100000],
  'bars': [9, 100000],
  'petabar': [9, 100000000000000000000],
  'petabars': [9, 100000000000000000000],
  'Pbar': [9, 100000000000000000000],
  'terabar': [9, 100000000000000000],
  'terabars': [9, 100000000000000000],
  'Tbar': [9, 100000000000000000],
  'gigabar': [9, 100000000000000],
  'gigabars': [9, 100000000000000],
  'Gbar': [9, 100000000000000],
  'megabar': [9, 100000000000],
  'megabars': [9, 100000000000],
  'Mbar': [9, 100000000000],
  'kilobar': [9, 100000000],
  'kilobars': [9, 100000000],
  'kbar': [9, 100000000],
  'hectobar': [9, 10000000],
  'hectobars': [9, 10000000],
  'hbar': [9, 10000000],
  'decabar': [9, 1000000],
  'decabars': [9, 1000000],
  'dabar': [9, 1000000],
  'decibar': [9, 10000],
  'decibars': [9, 10000],
  'dbar': [9, 10000],
  'centibar': [9, 1000],
  'centibars': [9, 1000],
  'cbar': [9, 1000],
  'millibar': [9, 100],
  'millibars': [9, 100],
  'mbar': [9, 100],
  'microbar': [9, 0.1],
  'microbars': [9, 0.1],
  'μbar': [9, 0.1],
  'µbar': [9, 0.1],
  'nanobar': [9, 0.0001],
  'nanobars': [9, 0.0001],
  'nbar': [9, 0.0001],
  'picobar': [9, 1e-7],
  'picobars': [9, 1e-7],
  'pbar': [9, 1e-7],
  'femtobar': [9, 1e-10],
  'femtobars': [9, 1e-10],
  'fbar': [9, 1e-10],
  'torr': [9, 133.32236842105263157895],
  'torrs': [9, 133.32236842105263157895],
  'Torr': [9, 133.32236842105263157895],
  'millitorr': [9, 0.13332236842105263158],
  'mTorr': [9, 0.13332236842105263158],
  'atmosphere': [9, 101325],
  'atmospheres': [9, 101325],
  'atm': [9, 101325],
  'pound per square inch': [9, 6894.757],
  'pounds per square inch': [9, 6894.757],
  'psi': [9, 6894.757],
  'lbf/in2': [9, 6894.757],
  'lbf/in²': [9, 6894.757],
  'inch of water': [9, 249.0889],
  'inches of water': [9, 249.0889],
  'inAq': [9, 249.0889],
  'Aq': [9, 249.0889],
  'inch of mercury': [9, 3386.389],
  'inches of mercury': [9, 3386.389],
  'inHg': [9, 3386.389],
  'Hg': [9, 3386.389],
  'kelvin': [10, 1],
  'kelvins': [10, 1],
  'K': [10, 1],
  'petakelvin': [10, 1000000000000000],
  'petakelvins': [10, 1000000000000000],
  'PK': [10, 1000000000000000],
  'terakelvin': [10, 1000000000000],
  'terakelvins': [10, 1000000000000],
  'TK': [10, 1000000000000],
  'gigakelvin': [10, 1000000000],
  'gigakelvins': [10, 1000000000],
  'GK': [10, 1000000000],
  'megakelvin': [10, 1000000],
  'megakelvins': [10, 1000000],
  'MK': [10, 1000000],
  'kilokelvin': [10, 1000],
  'kilokelvins': [10, 1000],
  'kK': [10, 1000],
  'hectokelvin': [10, 100],
  'hectokelvins': [10, 100],
  'hK': [10, 100],
  'decakelvin': [10, 10],
  'decakelvins': [10, 10],
  'daK': [10, 10],
  'decikelvin': [10, 0.1],
  'decikelvins': [10, 0.1],
  'dK': [10, 0.1],
  'centikelvin': [10, 0.01],
  'centikelvins': [10, 0.01],
  'cK': [10, 0.01],
  'millikelvin': [10, 0.001],
  'millikelvins': [10, 0.001],
  'mK': [10, 0.001],
  'microkelvin': [10, 0.000001],
  'microkelvins': [10, 0.000001],
  'μK': [10, 0.000001],
  'µK': [10, 0.000001],
  'nanokelvin': [10, 1e-9],
  'nanokelvins': [10, 1e-9],
  'nK': [10, 1e-9],
  'picokelvin': [10, 1e-12],
  'picokelvins': [10, 1e-12],
  'pK': [10, 1e-12],
  'femtokelvin': [10, 1e-15],
  'femtokelvins': [10, 1e-15],
  'fK': [10, 1e-15],
  'fahrenheit': [10, 0.5555555555555556],
  'F': [10, 0.5555555555555556],
  '°F': [10, 0.5555555555555556],
  'celsius': [10, 1],
  'C': [10, 1],
  '°C': [10, 1],
  'rankine': [10, 0.5555555555555556],
  'R': [10, 0.5555555555555556],
  'second': [11, 1],
  'seconds': [11, 1],
  's': [11, 1],
  'petasecond': [11, 1000000000000000],
  'petaseconds': [11, 1000000000000000],
  'Ps': [11, 1000000000000000],
  'terasecond': [11, 1000000000000],
  'teraseconds': [11, 1000000000000],
  'Ts': [11, 1000000000000],
  'gigasecond': [11, 1000000000],
  'gigaseconds': [11, 1000000000],
  'Gs': [11, 1000000000],
  'megasecond': [11, 1000000],
  'megaseconds': [11, 1000000],
  'Ms': [11, 1000000],
  'kilosecond': [11, 1000],
  'kiloseconds': [11, 1000],
  'ks': [11, 1000],
  'hectosecond': [11, 100],
  'hectoseconds': [11, 100],
  'hs': [11, 100],
  'decasecond': [11, 10],
  'decaseconds': [11, 10],
  'das': [11, 10],
  'decisecond': [11, 0.1],
  'deciseconds': [11, 0.1],
  'ds': [11, 0.1],
  'centisecond': [11, 0.01],
  'centiseconds': [11, 0.01],
  'cs': [11, 0.01],
  'millisecond': [11, 0.001],
  'milliseconds': [11, 0.001],
  'ms': [11, 0.001],
  'microsecond': [11, 0.000001],
  'microseconds': [11, 0.000001],
  'μs': [11, 0.000001],
  'µs': [11, 0.000001],
  'nanosecond': [11, 1e-9],
  'nanoseconds': [11, 1e-9],
  'ns': [11, 1e-9],
  'picosecond': [11, 1e-12],
  'picoseconds': [11, 1e-12],
  'ps': [11, 1e-12],
  'femtosecond': [11, 1e-15],
  'femtoseconds': [11, 1e-15],
  'fs': [11, 1e-15],
  'minute': [11, 60],
  'minutes': [11, 60],
  'min': [11, 60],
  'hour': [11, 3600],
  'hours': [11, 3600],
  'h': [11, 3600],
  'milliday': [11, 86.4],
  'millidays': [11, 86.4],
  'md': [11, 86.4],
  'day': [11, 86400],
  'days': [11, 86400],
  'd': [11, 86400],
  'week': [11, 604800],
  'weeks': [11, 604800],
  'wk': [11, 604800],
  'fortnight': [11, 1209600],
  'fortnights': [11, 1209600],
  'fn': [11, 1209600],
  'month': [11, 2592000],
  'months': [11, 2592000],
  'mo': [11, 2592000],
  'year': [11, 31536000],
  'years': [11, 31536000],
  'a': [11, 31536000],
  'y': [11, 31536000],
  'yr': [11, 31536000],
  'decade': [11, 315569520],
  'decades': [11, 315569520],
  'dec': [11, 315569520],
  'century': [11, 3155695200],
  'centuries': [11, 3155695200],
  'millennium': [11, 31556952000],
  'millennia': [11, 31556952000],
  'moment': [11, 90],
  'moments': [11, 90],
  'shake': [11, 1e-8],
  'shakes': [11, 1e-8],
  'time unit': [11, 0.001024],
  'TU': [11, 0.001024],
  'svedberg': [11, 1e-13],
  'svedbergs': [11, 1e-13],
  'S': [11, 1e-13],
  'cubic meter': [12, 1],
  'cubic meters': [12, 1],
  'cubic metre': [12, 1],
  'cubic metres': [12, 1],
  'stere': [12, 1],
  'steres': [12, 1],
  'm³': [12, 1],
  'm3': [12, 1],
  'cubic petameter': [12, 1e+45],
  'cubic petameters': [12, 1e+45],
  'Pm3': [12, 1e+45],
  'Pm³': [12, 1e+45],
  'cubic terameter': [12, 1e+36],
  'cubic terameters': [12, 1e+36],
  'Tm3': [12, 1e+36],
  'Tm³': [12, 1e+36],
  'cubic gigameter': [12, 1e+27],
  'cubic gigameters': [12, 1e+27],
  'Gm3': [12, 1e+27],
  'Gm³': [12, 1e+27],
  'cubic megameter': [12, 1000000000000000000],
  'cubic megameters': [12, 1000000000000000000],
  'Mm3': [12, 1000000000000000000],
  'Mm³': [12, 1000000000000000000],
  'cubic kilometer': [12, 1000000000],
  'cubic kilometers': [12, 1000000000],
  'km3': [12, 1000000000],
  'km³': [12, 1000000000],
  'cubic hectometer': [12, 1000000],
  'cubic hectometers': [12, 1000000],
  'hm3': [12, 1000000],
  'hm³': [12, 1000000],
  'cubic decameter': [12, 1000],
  'cubic decameters': [12, 1000],
  'dam3': [12, 1000],
  'dam³': [12, 1000],
  'cubic decimeter': [12, 0.001],
  'cubic decimeters': [12, 0.001],
  'dm3': [12, 0.001],
  'dm³': [12, 0.001],
  'cubic centimeter': [12, 0.000001],
  'cubic centimeters': [12, 0.000001],
  'cm3': [12, 0.000001],
  'cm³': [12, 0.000001],
  'cubic millimeter': [12, 1e-9],
  'cubic millimeters': [12, 1e-9],
  'mm3': [12, 1e-9],
  'mm³': [12, 1e-9],
  'cubic micrometer': [12, 1e-18],
  'cubic micrometers': [12, 1e-18],
  'μm3': [12, 1e-18],
  'µm3': [12, 1e-18],
  'μm³': [12, 1e-18],
  'µm³': [12, 1e-18],
  'cubic nanometer': [12, 1e-27],
  'cubic nanometers': [12, 1e-27],
  'nm3': [12, 1e-27],
  'nm³': [12, 1e-27],
  'cubic picometer': [12, 1e-36],
  'cubic picometers': [12, 1e-36],
  'pm3': [12, 1e-36],
  'pm³': [12, 1e-36],
  'cubic femtometer': [12, 1e-45],
  'cubic femtometers': [12, 1e-45],
  'fm3': [12, 1e-45],
  'fm³': [12, 1e-45],
  'liter': [12, 0.001],
  'liters': [12, 0.001],
  'litre': [12, 0.001],
  'litres': [12, 0.001],
  'l': [12, 0.001],
  'L': [12, 0.001],
  'petaliter': [12, 1000000000000],
  'petaliters': [12, 1000000000000],
  'petalitre': [12, 1000000000000],
  'petalitres': [12, 1000000000000],
  'Pl': [12, 1000000000000],
  'PL': [12, 1000000000000],
  'teraliter': [12, 1000000000],
  'teraliters': [12, 1000000000],
  'teralitre': [12, 1000000000],
  'teralitres': [12, 1000000000],
  'Tl': [12, 1000000000],
  'TL': [12, 1000000000],
  'gigaliter': [12, 1000000],
  'gigaliters': [12, 1000000],
  'gigalitre': [12, 1000000],
  'gigalitres': [12, 1000000],
  'Gl': [12, 1000000],
  'GL': [12, 1000000],
  'megaliter': [12, 1000],
  'megaliters': [12, 1000],
  'megalitre': [12, 1000],
  'megalitres': [12, 1000],
  'Ml': [12, 1000],
  'ML': [12, 1000],
  'kiloliter': [12, 1],
  'kiloliters': [12, 1],
  'kilolitre': [12, 1],
  'kilolitres': [12, 1],
  'kl': [12, 1],
  'kL': [12, 1],
  'hectoliter': [12, 0.1],
  'hectoliters': [12, 0.1],
  'hectolitre': [12, 0.1],
  'hectolitres': [12, 0.1],
  'hl': [12, 0.1],
  'hL': [12, 0.1],
  'decaliter': [12, 0.01],
  'decaliters': [12, 0.01],
  'decalitre': [12, 0.01],
  'decalitres': [12, 0.01],
  'dal': [12, 0.01],
  'daL': [12, 0.01],
  'deciliter': [12, 0.0001],
  'deciliters': [12, 0.0001],
  'decilitre': [12, 0.0001],
  'decilitres': [12, 0.0001],
  'dl': [12, 0.0001],
  'dL': [12, 0.0001],
  'centiliter': [12, 0.00001],
  'centiliters': [12, 0.00001],
  'centilitre': [12, 0.00001],
  'centilitres': [12, 0.00001],
  'cl': [12, 0.00001],
  'cL': [12, 0.00001],
  'milliliter': [12, 0.000001],
  'milliliters': [12, 0.000001],
  'millilitre': [12, 0.000001],
  'millilitres': [12, 0.000001],
  'ml': [12, 0.000001],
  'mL': [12, 0.000001],
  'microliter': [12, 1e-9],
  'microliters': [12, 1e-9],
  'microlitre': [12, 1e-9],
  'microlitres': [12, 1e-9],
  'μl': [12, 1e-9],
  'µl': [12, 1e-9],
  'μL': [12, 1e-9],
  'µL': [12, 1e-9],
  'nanoliter': [12, 1e-12],
  'nanoliters': [12, 1e-12],
  'nanolitre': [12, 1e-12],
  'nanolitres': [12, 1e-12],
  'nl': [12, 1e-12],
  'nL': [12, 1e-12],
  'picoliter': [12, 1e-15],
  'picoliters': [12, 1e-15],
  'picolitre': [12, 1e-15],
  'picolitres': [12, 1e-15],
  'pl': [12, 1e-15],
  'pL': [12, 1e-15],
  'femtoliter': [12, 1e-18],
  'femtoliters': [12, 1e-18],
  'femtolitre': [12, 1e-18],
  'femtolitres': [12, 1e-18],
  'fl': [12, 1e-18],
  'fL': [12, 1e-18],
  'cubic mile': [12, 4200],
  'cubic miles': [12, 4200],
  'cu mi': [12, 4200],
  'mi3': [12, 4200],
  'mi³': [12, 4200],
  'acre-foot': [12, 1233.48183754752],
  'acre-feet': [12, 1233.48183754752],
  'ac⋅ft': [12, 1233.48183754752],
  'ac ft': [12, 1233.48183754752],
  'cubic yard': [12, 0.764554857984],
  'cubic yards': [12, 0.764554857984],
  'cu yd': [12, 0.764554857984],
  'yd3': [12, 0.764554857984],
  'yd³': [12, 0.764554857984],
  'cubic foot': [12, 0.028316846592],
  'cubic feet': [12, 0.028316846592],
  'cu ft': [12, 0.028316846592],
  'ft3': [12, 0.028316846592],
  'ft³': [12, 0.028316846592],
  'board foot': [12, 0.002359737],
  'board feet': [12, 0.002359737],
  'cubic inch': [12, 0.000016387064],
  'cubic inches': [12, 0.000016387064],
  'cu in': [12, 0.000016387064],
  'in3': [12, 0.000016387064],
  'in³': [12, 0.000016387064],
  'measurement ton': [12, 1.133],
  'measurement tons': [12, 1.133],
  'MTON': [12, 1.133],
  'imperial barrel': [12, 0.16],
  'imperial barrels': [12, 0.16],
  'imp bbl': [12, 0.16],
  'imperial bushel': [12, 0.03636872],
  'imperial bushels': [12, 0.03636872],
  'imp bsh': [12, 0.03636872],
  'imp bu': [12, 0.03636872],
  'imperial peck': [12, 0.00909218],
  'imperial pecks': [12, 0.00909218],
  'pk': [12, 0.00909218],
  'imp pk': [12, 0.00909218],
  'imperial gallon': [12, 0.00454609],
  'imperial gallons': [12, 0.00454609],
  'imp gal': [12, 0.00454609],
  'imperial quart': [12, 0.0011365225],
  'imperial quarts': [12, 0.0011365225],
  'imp qt': [12, 0.0011365225],
  'imperial pint': [12, 0.00056826125],
  'imperial pints': [12, 0.00056826125],
  'imp pt': [12, 0.00056826125],
  'imperial fluid ounce': [12, 0.0000284130625],
  'imperial fluid ounces': [12, 0.0000284130625],
  'imp fl oz': [12, 0.0000284130625],
  'teaspoon': [12, 0.00000492892159375],
  'teaspoons': [12, 0.00000492892159375],
  'US teaspoon': [12, 0.00000492892159375],
  'US teaspoons': [12, 0.00000492892159375],
  'tsp': [12, 0.00000492892159375],
  'tablespoon': [12, 0.00001478676478125],
  'tablespoons': [12, 0.00001478676478125],
  'US tablespoon': [12, 0.00001478676478125],
  'US tablespoons': [12, 0.00001478676478125],
  'tbsp': [12, 0.00001478676478125],
  'US fluid ounce': [12, 0.0000295735295625],
  'US fluid ounces': [12, 0.0000295735295625],
  'fl oz': [12, 0.0000295735295625],
  'fl. oz.': [12, 0.0000295735295625],
  'oz. fl.': [12, 0.0000295735295625],
  'cup': [12, 0.0002365882365],
  'cups': [12, 0.0002365882365],
  'c': [12, 0.0002365882365],
  'US legal cup': [12, 0.00024],
  'US legal cups': [12, 0.00024],
  'US lc': [12, 0.00024],
  'pint': [12, 0.000473176473],
  'pints': [12, 0.000473176473],
  'US liquid pint': [12, 0.000473176473],
  'US liquid pints': [12, 0.000473176473],
  'pt': [12, 0.000473176473],
  'p': [12, 0.000473176473],
  'quart': [12, 0.000946352946],
  'quarts': [12, 0.000946352946],
  'US liquid quart': [12, 0.000946352946],
  'US liquid quarts': [12, 0.000946352946],
  'qt': [12, 0.000946352946],
  'gallon': [12, 0.003785411784],
  'gallons': [12, 0.003785411784],
  'US liquid gallon': [12, 0.003785411784],
  'US liquid gallons': [12, 0.003785411784],
  'gal': [12, 0.003785411784],
  'US bushel': [12, 0.03523907016688],
  'US bushels': [12, 0.03523907016688],
  'US bsh': [12, 0.03523907016688],
  'US bu': [12, 0.03523907016688],
  'US peck': [12, 0.00880976754172],
  'US pk': [12, 0.00880976754172],
  'US dry gallon': [12, 0.00440488377086],
  'US dry gal': [12, 0.00440488377086],
  'US dry barrel': [12, 0.1156],
  'US dry barrels': [12, 0.1156],
  'US dry bbl': [12, 0.1156],
  'US dry quart': [12, 0.001101220942715],
  'US dry qt': [12, 0.001101220942715],
  'US dry pint': [12, 0.0005506104713575],
  'US dry pt': [12, 0.0005506104713575],
} as const;

export const differences = {
  'fahrenheit': 459.67,
  'F': 459.67,
  '°F': 459.67,
  'celsius': 273.15,
  'C': 273.15,
  '°C': 273.15,
} as const;